/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// c-price-list__product-numを検索
// c-price-list__product-numの文字列で数字部分のみspanで囲む
// 全ての商品カード対象
document.addEventListener("DOMContentLoaded", function () {
  // c-price-list__product-numクラスの要素を全て取得
  const productNumElements = document.querySelectorAll(".c-price-list__product-num");

  productNumElements.forEach(function (element) {
    // 要素のテキスト内容を取得
    const text = element.textContent;

    // 数字部分を検索する正規表現（整数と小数点を含む）
    const numberRegex = /(\d+(?:\.\d+)?)/g;

    // 数字部分をspanで囲んで置換
    const newText = text.replace(numberRegex, "<span>$1</span>");

    // HTMLとして設定
    element.innerHTML = newText;
  });
});

// 動的に追加される要素にも対応するため、MutationObserverを使用
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.type === "childList") {
      // 新しく追加されたノードをチェック
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // 新しく追加された要素内のc-price-list__product-numをチェック
          const newProductNumElements = node.querySelectorAll ? node.querySelectorAll(".c-price-list__product-num") : [];
          newProductNumElements.forEach(function (element) {
            const text = element.textContent;
            const numberRegex = /(\d+(?:\.\d+)?)/g;
            const newText = text.replace(numberRegex, "<span>$1</span>");
            element.innerHTML = newText;
          });

          // 要素自体がc-price-list__product-numクラスの場合
          if (node.classList && node.classList.contains("c-price-list__product-num")) {
            const text = node.textContent;
            const numberRegex = /(\d+(?:\.\d+)?)/g;
            const newText = text.replace(numberRegex, "<span>$1</span>");
            node.innerHTML = newText;
          }
        }
      });
    }
  });
});

// オブザーバーを開始
observer.observe(document.body, {
  childList: true,
  subtree: true,
});

//customFixedCtaの表示制御
let retryCount = 0;
const MAX_RETRY_COUNT = 50; // 最大リトライ回数（5秒間）

function initCustomFixedCta() {
  try {
    const customFixedCta = document.getElementById("customFixedCta");

    if (!customFixedCta) {
      if (retryCount < MAX_RETRY_COUNT) {
        retryCount++;
        setTimeout(initCustomFixedCta, 100);
        return;
      } else {
        return;
      }
    }

    // メインフッターを取得（mini-cartのfooterではない）
    const footer = document.querySelector("footer:not(.mini-cart__drawer-footer)") || document.querySelector("footer") || document.querySelector(".footer");
    let isVisible = false;

    function updateCtaVisibility() {
      try {
        // customFixedCtaが存在するか再確認
        if (!customFixedCta || !document.contains(customFixedCta)) {
          window.removeEventListener("scroll", handleScroll);
          return;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;

        // ページトップから100px以内かチェック
        const isAtTop = scrollTop <= 100;

        // footer到達チェック（ラベル分50pxオフセット）
        let isAtFooter = false;
        if (footer && document.contains(footer)) {
          const footerRect = footer.getBoundingClientRect();
          const footerBottom = footerRect.bottom;
          isAtFooter = footerBottom <= windowHeight + 50;
        }

        // 表示制御ロジック
        if (isAtTop || isAtFooter) {
          // トップ100px以内またはfooter到達時は非表示
          if (isVisible) {
            customFixedCta.classList.remove("show");
            isVisible = false;
          }
        } else if (scrollTop > 100) {
          // スクロール100px以上で表示
          if (!isVisible) {
            customFixedCta.classList.add("show");
            isVisible = true;
          }
        }
      } catch (error) {
        // エラーが発生した場合は何もしない
        return;
      }
    }

    // スクロールイベントリスナー（throttle付き）
    let scrollTimeout;
    function handleScroll() {
      try {
        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
        }
        scrollTimeout = setTimeout(updateCtaVisibility, 10);
      } catch (error) {
        // エラーが発生した場合は何もしない
        return;
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true });

    // 初期チェック
    updateCtaVisibility();
  } catch (error) {
    // エラーが発生した場合は何もしない
    return;
  }
}

// DOMContentLoadedとwindow.onloadの両方で試す
document.addEventListener("DOMContentLoaded", initCustomFixedCta);
window.addEventListener("load", initCustomFixedCta);

// .c-product-meta__num-textが存在していたとき、数字の部分をspanで囲む
function wrapNumbersInSpan() {
  try {
    const numTextElements = document.querySelectorAll(".c-product-meta__num-text");
    if (!numTextElements.length) return;

    numTextElements.forEach((element) => {
      const text = element.textContent;
      // 数字にマッチする正規表現
      const regex = /(\d+)/g;
      // 数字を<span>で囲む
      const newText = text.replace(regex, '<span class="number">$1</span>');
      element.innerHTML = newText;
    });
  } catch (error) {
    return;
  }
}

// DOMContentLoadedとwindow.onloadの両方で実行
document.addEventListener("DOMContentLoaded", wrapNumbersInSpan);
window.addEventListener("load", wrapNumbersInSpan);

// シンプルなアコーディオン機能
document.addEventListener("DOMContentLoaded", function () {
  try {
    const accordionTitles = document.querySelectorAll(".c-product-detail__accordion-title");

    if (!accordionTitles || accordionTitles.length === 0) {
      return;
    }

    accordionTitles.forEach(function (title) {
      try {
        const content = title.nextElementSibling;
        const icon = title.querySelector(".c-product-detail__icon");
        const contentWrapper = title.closest(".c-product-detail__content");
        const iconPlus = title.querySelector(".c-product-detail__icon-plus");
        const iconMinus = title.querySelector(".c-product-detail__icon-minus");

        if (!content || !icon || !contentWrapper || !iconPlus || !iconMinus) return;

        // 初期状態は閉じている
        content.style.maxHeight = "0";
        content.style.marginBlockStart = "0";
        contentWrapper.classList.remove("active");
        title.classList.remove("active");
        iconPlus.style.display = "block";
        iconMinus.style.display = "none";

        title.addEventListener("click", function (e) {
          try {
            e.preventDefault();

            const isOpen = title.classList.contains("active");

            if (isOpen) {
              // 閉じる
              title.classList.remove("active");
              contentWrapper.classList.remove("active");
              content.style.maxHeight = "0";
              content.style.marginBlockStart = "0";
              iconPlus.style.display = "block";
              iconMinus.style.display = "none";
            } else {
              // 開く
              title.classList.add("active");
              contentWrapper.classList.add("active");
              content.style.maxHeight = content.scrollHeight + "px";
              content.style.marginBlockStart = "22px";
              iconPlus.style.display = "none";
              iconMinus.style.display = "block";
            }
          } catch (error) {
            return;
          }
        });
      } catch (error) {
        return;
      }
    });
  } catch (error) {
    return;
  }
});

// judge.meのスタイルを動的に変更
function updateJudgeMeStyles() {
  try {
    // スタイルシートが既に存在するかチェック
    let existingStyle = document.getElementById("judge-me-custom-styles");

    if (!existingStyle) {
      // 新しいスタイル要素を作成
      const style = document.createElement("style");
      style.id = "judge-me-custom-styles";
      style.textContent = `
        .jdgm-star.jdgm--off:before {
          content: "\\e000";
          color: #D1D1D1;
          -webkit-text-stroke-width: 1px;
          -webkit-text-stroke-color: #000;
        }
      `;

      // headに追加
      document.head.appendChild(style);
    }
  } catch (error) {
    // エラーが発生した場合は何もしない
    return;
  }
}

// DOMContentLoadedとwindow.onloadの両方で実行
document.addEventListener("DOMContentLoaded", updateJudgeMeStyles);
window.addEventListener("load", updateJudgeMeStyles);

// 動的に追加される要素にも対応するため、MutationObserverを使用
const judgeMeObserver = new MutationObserver(function (mutations) {
  try {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        // 新しく追加されたノードをチェック
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // judge.meの要素が追加されたかチェック
            const judgeMeElements = node.querySelectorAll ? node.querySelectorAll(".jdgm-star, .jdgm-widget") : [];
            if (judgeMeElements.length > 0) {
              updateJudgeMeStyles();
            }

            // 要素自体がjudge.meの要素の場合
            if (node.classList && (node.classList.contains("jdgm-star") || node.classList.contains("jdgm-widget"))) {
              updateJudgeMeStyles();
            }
          }
        });
      }
    });
  } catch (error) {
    // エラーが発生した場合は何もしない
    return;
  }
});

// オブザーバーを開始
judgeMeObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

// .c-recipe-detail__time-textの文字列で"分"があればspanで囲む
function wrapMinuteText() {
  try {
    const timeTextElements = document.querySelectorAll(".c-recipe-detail__time-text");
    if (!timeTextElements.length) return;

    timeTextElements.forEach((element) => {
      const text = element.textContent;
      // "分"を含む文字列を検索する正規表現
      const minuteRegex = /(分)/g;
      // "分"を<span>で囲む
      const newText = text.replace(minuteRegex, "<span>$1</span>");
      element.innerHTML = newText;
    });
  } catch (error) {
    return;
  }
}

// DOMContentLoadedとwindow.onloadの両方で実行
document.addEventListener("DOMContentLoaded", wrapMinuteText);
window.addEventListener("load", wrapMinuteText);

// 動的に追加される要素にも対応するため、MutationObserverを使用
const minuteTextObserver = new MutationObserver(function (mutations) {
  try {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        // 新しく追加されたノードをチェック
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // 新しく追加された要素内のc-recipe-detail__time-textをチェック
            const newTimeTextElements = node.querySelectorAll ? node.querySelectorAll(".c-recipe-detail__time-text") : [];
            newTimeTextElements.forEach(function (element) {
              const text = element.textContent;
              const minuteRegex = /(分)/g;
              const newText = text.replace(minuteRegex, "<span>$1</span>");
              element.innerHTML = newText;
            });

            // 要素自体がc-recipe-detail__time-textクラスの場合
            if (node.classList && node.classList.contains("c-recipe-detail__time-text")) {
              const text = node.textContent;
              const minuteRegex = /(分)/g;
              const newText = text.replace(minuteRegex, "<span>$1</span>");
              node.innerHTML = newText;
            }
          }
        });
      }
    });
  } catch (error) {
    return;
  }
});

// オブザーバーを開始
minuteTextObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

// 374px未満のデバイスのレスポンシブ対応
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');

  function switchViewport() {
    const value = window.outerWidth > 374 ? "width=device-width,initial-scale=1" : "width=374";

    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }

  addEventListener("resize", switchViewport, false);
  switchViewport();
})();
